import model from "../model.js";

export default function(){
	let pages = [];

	model.on('OpenPage', function(e){
		const activePage = pages.find(page => page.classList.contains('active-page'));
		if (activePage) activePage.classList.remove('active-page');

		const targetPage = pages.find(page => page.dataset.page === e.page);
		if (targetPage) targetPage.classList.add('active-page');

		model.observables.activePage = e.page;
		model.dispatchEvent('UpdateActiveTab');
	});

	model.vue.app.directive('page', {
		beforeMount(element, binding){
			const page = element;
			
			const id = binding.value;
			if (!id) throw 'Page ID is not defined!';

			page.setAttribute('data-page', id);
			if (model.isMobile) page.classList.add('mobile');

			if (model.isPage(id)) {
				const activePage = pages.find(p => p.classList.contains('active-page'));
				if (activePage) activePage.classList.remove('active-page');

				page.classList.add('active-page');
			}

			pages.push(page);
		},
	});
}